//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MaterialInput from "@Shared/components/inputs/material-input";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SwitchableInput",
  components: {
    MaterialInput
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    titleText: {
      type: String,
      default: "description"
    },
    placeholder: {
      type: String,
      default: ""
    },
    noMargin: {
      type: Boolean,
      default: false
    },
    textClass: {
      type: String,
      default: "text-primary"
    },
    inputStyle: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      editing: false,
      text: "",
      clickOutsideNonce: 0
    };
  },
  watch: {
    editing(value) {
      if (value) {
        this.text = this.titleText;
        this.$nextTick(() => {
          this.$refs.textInput.focus();
        });
      }
    }
  },
  methods: {
    toggleEditing(value) {
      this.editing = value != null ? value : !this.editing;
      this.$emit("editing", this.editing);
    },
    handleEdit() {
      if (!this.editing) return;
      this.$emit("save", this.text);
      this.toggleEditing(false);
    },
    handleClickOutside() {
      this.clickOutsideNonce++;
      if (this.clickOutsideNonce > 0) {
        this.clickOutsideNonce = 0;
        this.handleEdit();
      }
    }
  }
});